import { Box, Text } from '@bonusly/design-system';

import { BizyAnimatedMessage } from './bizy-animated-message';
import { ChatMessage } from './use-bizy-chat';

interface BizyChatMessageProps {
	message: ChatMessage;
	isStreaming?: boolean;
	onContentUpdate?: () => void;
}

export function BizyChatMessage({ message, isStreaming = false, onContentUpdate }: BizyChatMessageProps) {
	const isUser = message.role === 'user';

	// user messages show immediately, assistant messages animate
	if (isUser) {
		return (
			<Box
				alignSelf="flex-end"
				maxWidth="85%"
				bg="blue.500"
				color="white"
				px={3}
				py={2}
				borderRadius="lg"
				borderBottomRightRadius="sm"
				borderBottomLeftRadius="lg"
			>
				<Text fontSize="sm">{message.content}</Text>
			</Box>
		);
	}

	return <BizyAnimatedMessage content={message.content} isComplete={!isStreaming} onContentUpdate={onContentUpdate} />;
}
